import { render, staticRenderFns } from "./lawofflatestin.vue?vue&type=template&id=3457680e&scoped=true&"
import script from "./lawofflatestin.vue?vue&type=script&lang=js&"
export * from "./lawofflatestin.vue?vue&type=script&lang=js&"
import style0 from "./lawofflatestin.vue?vue&type=style&index=0&id=3457680e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3457680e",
  null
  
)

export default component.exports